import {CustomDataTable} from '@/components/organisms'
import {useProductListForModal} from '@/hooks/promotion/useProductListForModal'
import {useDataTable} from '@/hooks/useDataTable-hook'
import {productsTableHeader} from '@/services/MockData/Promotions/ProductTableColumns'
import {PRODUCT_ID_TYPE, COMBO_ID_TYPE, BuyType} from '@/utils/constants/promotionConstants'
import {useCallback, useMemo, useState} from 'react'
import './ProductIdContent.styles.css'
import {comboProductsTableHeader} from '@/utils/productCombo/productComboConstants'


const ProductIdContent = ({onSelection, combination, setCombination, isExclude, selectedValues = [], type = BuyType.PRODUCT_ID}) => {
  const {
    searchArr,
    sortingObj,
    pageIndex,
    setSearchArry,
    setSortingObj,
    onPageIndexChange,
    createSearchArray,
    resetAllBtnClicked,
  } = useDataTable()
  const [isSelectAll, setSelectAll] = useState(false)

  const {products, isLoading} = useProductListForModal(searchArr, sortingObj, pageIndex, type)

  const isCombo = type === BuyType.COMBO_ID

  const customTableColumns = useMemo(() => {
    const header = isCombo ? comboProductsTableHeader : productsTableHeader
    return header.map(col => ({
      name_of_db_column: col.columnKey,
      label_of_column: col.header,
      order_of_column: 1,
    }))
  }, [])

  const initialSelectedRows = useMemo(() => {
    if (!selectedValues || selectedValues.length === 0) return []

    return selectedValues.map(selectedValue => {
      const productId = selectedValue.id
      const matchingProduct = products?.data?.find(item => item.productId === productId)

      return (
        matchingProduct || {
          productId: productId,
          productName: selectedValue.displayText,
          gtin: '',
          category: '',
          brand: '',
        }
      )
    })
  }, [selectedValues, products?.data])

  const handleRowSelection = useCallback(
    selectedRowsData => {
      if (selectedRowsData && selectedRowsData.length > 0) {
        onSelection({
          itemType: isCombo ? COMBO_ID_TYPE : PRODUCT_ID_TYPE,
          values: selectedRowsData
            .map(item => ({
              id: item?.productId || '',
              displayText: item?.productName || item?.name || '',
            }))
            .filter(item => item.id), // Filter out any items with empty IDs
        })
      } else {
        onSelection({itemType: isCombo ? COMBO_ID_TYPE : PRODUCT_ID_TYPE, values: []})
      }
    },
    [onSelection]
  )

  // Handle reset all functionality
  const handleResetAll = useCallback(() => {
    setSortingObj({})
    createSearchArray([])
    setSearchArry({})
    // Clear the selection
    onSelection({itemType: isCombo ? COMBO_ID_TYPE : PRODUCT_ID_TYPE, values: []})
  }, [setSortingObj, createSearchArray, setSearchArry, onSelection, isCombo])

  const handleCombinationToggle = value => {
    if (value !== undefined && value !== null) {
      setCombination(value)
    }
  }

  return (
    <>
      <div className="product-id-content-wrapper">
        <CustomDataTable
          columns={customTableColumns}
          records={products?.data || []}
          isLoading={isLoading}
          pageSize={10}
          totalRecords={products?.totalRecords || 0}
          setPageIndex={onPageIndexChange}
          handleSorting={setSortingObj}
          setSearchArry={setSearchArry}
          onRowSelect={handleRowSelection}
          onResetAll={() => {
            handleResetAll()
            resetAllBtnClicked()
          }}
          showActions={false}
          showResetAll={true}
          enableSelection={true}
          showColumnFilters={true}
          enableSorting={true}
          initialSelectedRows={initialSelectedRows}
          id="productId"
          setSelectAll={setSelectAll}
          isSelectAll={isSelectAll}
        />
      </div>
      {/* {!isExclude && (
        <div className="mt-4">
          <Toggle
            isDark
            updateValue={handleCombinationToggle}
            value={combination}
            uiSchema={{size: 'small', label: 'Combination of Products'}}
          />
        </div>
      )} */}
    </>
  )
}

export default ProductIdContent
